import { KYMW4801Component } from './kymw4801.component';
import { PlessViewUtils } from 'src/app/shared/utils/pless-view-utils.service';

/**
 * 
 * クロス設定登録画面の値を管理するクラス
 *
 * @export KYMW4801Model
 * @class KYMW4801Model
 */
export class KYMW4801Model {
  kymw4801Component: KYMW4801Component;

  /** クロスコード */
  public crossCode = String('');
  /** クロス商品情報一覧リスト */
  public crossGoodsInfoList: Array<any> = [];
  /** Pコード商品取得リスト */
  public pcodeGoodsInfoList: Array<any> = [];

  /**
   * クロスコード情報の取得
   */
  public setCrossCodeData(serverData: any): void {
    // クロスコードが取得できない場合はnull
    if (PlessViewUtils.isEmpty(serverData) || PlessViewUtils.isEmpty(serverData.CrossCode)) {
      this.crossCode = null
    } else {
      this.crossCode = serverData.CrossCode;
    }
  }

  /**
   * クロス商品情報一覧の取得
   */
  public setCrossGoodsInfoData(serverData: any): void {
    // データを初期化
    this.crossGoodsInfoList = [];
    // 結果を格納
    this.crossGoodsInfoList = serverData;
  }

  /**
   * クロス商品情報一覧へのデータ追加
   */
  public addCrossGoodsInfoData(serverData: any): void {
    const pushData = serverData;

    pushData.PublishSeq = this.crossGoodsInfoList.length + 1;
    pushData.ChildKomaSettings = 0;

    // 結果を格納
    this.pcodeGoodsInfoList[0] = pushData;
  }
}
